import script from "./promotionTrigger.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionTrigger.vue?vue&type=script&lang=ts&setup=true"

import "./promotionTrigger.vue?vue&type=style&index=0&id=1f56fa12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f56fa12"]])

export default __exports__